// extracted by mini-css-extract-plugin
export default {"container":"oYg0O","title-block":"z1Lh2","title":"vVUTp"};